import { BRAND } from "../data/landing";
import { trackCTA } from "../lib/analytics";

export default function Header() {
  return (
    <header
      className="sticky top-0 z-50 w-full bg-white backdrop-blur-xl border-b border-black/10 shadow-[0_2px_12px_rgba(5,11,38,0.06)]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1 flex items-center justify-between gap-4">
        <a
          href="#top"
          className="flex items-center group shrink-0"
          data-testid="logo-link"
        >
          <img
            src={BRAND.logoUrl}
            alt="Knight Media Group"
            className="h-14 sm:h-24 lg:h-32 w-auto object-contain"
            data-testid="kmg-logo"
          />
        </a>

        <nav className="hidden md:flex items-center gap-1.5 text-sm">
          <a href="#services" className="header-nav-tile" data-testid="nav-services">Services</a>
          <a href="#about" className="header-nav-tile" data-testid="nav-about">About</a>
          <a href="#work" className="header-nav-tile" data-testid="nav-work">Work</a>
          <a href="#contact" className="header-nav-tile" data-testid="nav-contact">Contact</a>
        </nav>

        <div className="flex items-center gap-2 sm:gap-2.5">
          <a
            href={BRAND.bookMeetingUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackCTA("Book A Meeting", "header")}
            className="btn-kmg inline-flex items-center justify-center bg-[#1440E1] hover:bg-[#1033B3] text-white text-[11px] px-2.5 py-1.5 sm:text-sm sm:px-[18px] sm:py-2 font-bold transition-colors tracking-wide whitespace-nowrap"
            data-testid="header-book-meeting-btn"
          >
            Book A Meeting
          </a>
          <a
            href={BRAND.clientPortalUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackCTA("Client Portal", "header")}
            className="btn-kmg inline-flex items-center justify-center bg-[#1440E1] hover:bg-[#1033B3] text-white text-[11px] px-2.5 py-1.5 sm:text-sm sm:px-[18px] sm:py-2 font-bold transition-colors tracking-wide whitespace-nowrap"
            data-testid="header-client-portal-btn"
          >
            Client Portal
          </a>
        </div>
      </div>
    </header>
  );
}
